module.exports = __webpack_public_path__ + "img/happy-workers.b8b6a250.jpg";